import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore, UserRole } from './store/authStore';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import DashboardPage from './pages/DashboardPage';
import ParentDashboardPage from './pages/ParentDashboardPage';
import StundenplanPage from './pages/StundenplanPage';
import TerminePage from './pages/TerminePage';
import PortalPage from './pages/PortalPage';
import SettingsPage from './pages/SettingsPage';
import HausaufgabenPage from './pages/HausaufgabenPage';
import TodosPage from './pages/TodosPage';
import NotenPage from './pages/NotenPage';
import AdminInvitesPage from './pages/AdminInvitesPage';
import ManuelleHAPage from './pages/ManuelleHAPage';
import StatistikPage from './pages/StatistikPage';
import ArbeitenPage from './pages/ArbeitenPage';
import {
  ElternbriefePage, ElternBrettPage, ElternTerminePage, ElternStundenplanPage,
  ElternVertretungsPage, ElternPaymentsPage, ElternKommunikationPage, ElternKollegiumPage,
} from './pages/ElternPortalSubPages';
import AboutPage from './pages/AboutPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';

const App: React.FC = () => {
  const { isAuthenticated, user, initAuth } = useAuthStore();

  useEffect(() => {
    initAuth();
  }, [initAuth]);

  const getDashboardRoute = () => {
    if (!isAuthenticated) return <Navigate to="/login" />;

    // Parent dashboard
    if (user?.role === UserRole.PARENT) {
      return <ParentDashboardPage />;
    }

    // Standard dashboard for students, teachers, etc.
    return <DashboardPage />;
  };

  return (
    <Router>
      <div className="min-h-screen bg-gray-900 dark">
        <Routes>
          <Route
            path="/login"
            element={!isAuthenticated ? <LoginPage /> : <Navigate to="/dashboard" />}
          />
          <Route
            path="/register"
            element={!isAuthenticated ? <RegisterPage /> : <Navigate to="/dashboard" />}
          />
          <Route path="/verify-email" element={<VerifyEmailPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/dashboard"
            element={getDashboardRoute()}
          />
          <Route path="/stundenplan" element={isAuthenticated ? <StundenplanPage /> : <Navigate to="/login" />} />
          <Route path="/termine" element={isAuthenticated ? <TerminePage /> : <Navigate to="/login" />} />
          <Route path="/hausaufgaben" element={isAuthenticated ? <HausaufgabenPage /> : <Navigate to="/login" />} />
          <Route path="/manuelle-hausaufgaben" element={isAuthenticated ? <ManuelleHAPage /> : <Navigate to="/login" />} />
          <Route path="/statistik" element={isAuthenticated ? <StatistikPage /> : <Navigate to="/login" />} />
          <Route path="/arbeiten" element={isAuthenticated ? <ArbeitenPage /> : <Navigate to="/login" />} />
          <Route path="/todos" element={isAuthenticated ? <TodosPage /> : <Navigate to="/login" />} />
          <Route path="/noten" element={isAuthenticated ? <NotenPage /> : <Navigate to="/login" />} />
          <Route path="/portal" element={isAuthenticated ? <PortalPage /> : <Navigate to="/login" />} />
          <Route path="/einstellungen" element={isAuthenticated ? <SettingsPage /> : <Navigate to="/login" />} />
          <Route path="/admin/invites" element={isAuthenticated ? <AdminInvitesPage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal" element={<Navigate to="/dashboard" replace />} />
          <Route path="/eltern-portal/briefe" element={isAuthenticated ? <ElternbriefePage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal/brett" element={isAuthenticated ? <ElternBrettPage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal/termine" element={isAuthenticated ? <ElternTerminePage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal/stundenplan" element={isAuthenticated ? <ElternStundenplanPage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal/vertretungsplan" element={isAuthenticated ? <ElternVertretungsPage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal/zahlungen" element={isAuthenticated ? <ElternPaymentsPage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal/kommunikation" element={isAuthenticated ? <ElternKommunikationPage /> : <Navigate to="/login" />} />
          <Route path="/eltern-portal/kollegium" element={isAuthenticated ? <ElternKollegiumPage /> : <Navigate to="/login" />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/datenschutz" element={<DatenschutzPage />} />
          <Route path="/" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
